module.exports = __webpack_public_path__ + "20240105162613/img/coming3.56111d4f.png";